export class Phone {
	constructor(phones = {}) {
		this.phones = phones;
		this.setBehavior();
	}

	setBehavior() {
		if (!BX.PhoneCallView) {
			return;
		}
		let self = this;

		let original = BX.PhoneCallView.prototype.renderTitle;
		BX.PhoneCallView.prototype.renderTitle = function () {
			let text = original.apply(this);
			let phoneName = self.phones[this.lineNumber];
			if (phoneName !== 'undefined') {
				text = text.replace(this.lineNumber, '<span>"' + phoneName + '"</span>');
			}
			return text;
		};
	}
}
